import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'weekBeginDelta'})
export class WeekBeginDeltaPipe implements PipeTransform {
    transform(value, delta) {
        let date = new Date(value);
        let day = date.getDay();
        let diff = date.getDate() + (delta * 7) - day + (day === 0 ? -6 : 1);
        return date.setDate(diff);
    }
}



// WEBPACK FOOTER //
// ./src/app/campaign/WeekBeginDeltaPipe.ts